import React, { useState } from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast } from "react-icons/md";
import BannerDetails from "../../assets/banner-detail.png";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import Contentimg from "../../assets/content-img.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MdCall } from "react-icons/md";
import Relateddeals from "../RelatedDeals/RelatedDeals";
import OtherDeals from "../OtherDeals/OtherDeals";
import { useEffect } from "react";
import { CouponDetailsApi } from "../../Utils/Api/CouponDetailsApi";
import { RelatedDealsApi } from "../../Utils/Api/RelatedDealsApi";
import { OtherDealsApi } from "../../Utils/Api/OtherDealsApi";
import copy from "copy-to-clipboard";
const CouponDetails = (props) => {
  const parameter = useParams();
  const coupon_id = parameter.id;
  const [coupondetail, setCoupondetail] = useState([]);
  const [otherdeals, setOtherdeals] = useState([]);
  const [relateddeals, setRelateddeals] = useState([]);
  const [showcode, setShowcode] = useState(false);

  const copyHandler = (code) => {
    if (code !== null) {
      copy(code);
      alert(`Copied "${code}"`);
    }
  };

  const navigate = useNavigate();

  const CouponDetailsHandler = async () => {
    const id = { coupon_id: 1 };
    const coupondetailData = await CouponDetailsApi(id, () => {
      navigate("/");
    });
    setCoupondetail(coupondetailData.res[0]);
  };
  const OtherDealsHandler = async () => {
    const data = {
      coupon_id: 1, //hardcode
      city_id: 1, //hardcoded
    };
    const otherdealsData = await OtherDealsApi(data, () => {
      navigate("/");
    });
    setOtherdeals(otherdealsData.res);
  };
  const RelatedDealsHandler = async () => {
    const data = {
      coupon_id: parseInt(coupon_id),
      business_id: 1, //hardcoded
    };
    const relateddealsData = await RelatedDealsApi(data, () => {
      navigate("/");
    });
    setRelateddeals(relateddealsData.res);
  };
  useEffect(() => {
    CouponDetailsHandler();
    OtherDealsHandler();
    RelatedDealsHandler();
  }, []);
  //view More
  const [viewMore, setviewMore] = useState(false);
  const extraContent = (
    <div>
      <ul className="extra-content">
        {/* <li>Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling jide fökarad benim. </li>
        <li>Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling jide fökarad benim.  </li> */}
        {coupondetail.about_business}
      </ul>
    </div>
  );
  const linkName = viewMore ? "View Less" : "View More";
  //read More
  const [readMore, setreadMore] = useState(false);
  const extraContentRead = (
    <div>
      <p className="extra-content">{coupondetail.about_business}</p>
    </div>
  );
  const linkNameRead = readMore ? "Read Less" : "Read More";
  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link to="/my-account/my-coupons">
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>

          <div className="my-3 inner-banner">
            <p className="banner-title">{coupondetail.about_business}</p>
          </div>
          <Row className="pt-2">
            <Col md="6" className="vou-content">
              <Image loading="lazy" src={Contentimg} width="100%"></Image>
              <div className="tag-main">
                {/* ask */}
                <p className="ribben">COUPON</p>
              </div>
            </Col>
            <Col md="6">
              <p className="vou-title mb-3">{coupondetail.coupon_title}</p>
              {/* coupondetail.product_avail_until_date */}
              <p>Available Until: Aug-15-2024</p>
              <p className="vou-about mb-3">
                <span className="vou-about-title">About this deal :</span>
                {coupondetail.coupon_description}
              </p>
              <p className="vou-about-title">Terms & Conditions : </p>
              <ul>
                {/* <li>Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling jide fökarad benim. </li>
            <li>Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling jide fökarad benim.  </li> */}
                {coupondetail.coupon_term_condition}
                {viewMore && extraContent}
                <p
                  className="read-more-link"
                  onClick={() => {
                    setviewMore(!viewMore);
                  }}
                >
                  {linkName}
                </p>
              </ul>
              <div className="d-flex mb-4">
                {/* <p className='loc-price-offer'>{coupondetail.coupon_title}</p> */}
              </div>
              <Row>
                <Col md="6" className="text-center mb-2">
                  {showcode === true ? (
                    <Button
                      variant="primary"
                      type="submit"
                      className="view-btn"
                      onClick={() => setShowcode(!showcode)}
                    >
                      {coupondetail.product_code} {""}
                      <Button
                        onClick={() => {
                          let code = coupondetail.product_code;
                          copyHandler(code);
                        }}
                      >
                        Copy
                      </Button>
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn"
                      onClick={() => setShowcode(!showcode)}
                    >
                      Show code {""}
                    </Button>
                  )}{" "}
                </Col>
                <Col md="6" className="text-center mb-2">
                  <Link>
                    <p className="view-btn">Share This Deal</p>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <p className="vou-about mt-4">
              <span className="vou-about-title">
                About {coupondetail.about_business} :{" "}
              </span>{" "}
              Lörem ipsum sesosa ultrahet plankning kys. Åbel kompetensväxling
              jide fökarad benim. Porade deneheten i operaosmos då memåska att
              agnostipod.
            </p>
            {readMore && extraContentRead}
            <p
              className="read-more-link mb-2"
              onClick={() => {
                setreadMore(!readMore);
              }}
            >
              {linkNameRead}
            </p>
            <p className="vou-about mb-2">
              <span className="vou-about-title">opening hours :</span>{" "}
              {coupondetail.bup_open_time} am to {coupondetail.bup_close_time}{" "}
              pm
            </p>
            <p className="vou-about mb-2">
              <span className="vou-about-title">Address :</span>{" "}
              {coupondetail.bup_address1}, {coupondetail.bup_address2}
            </p>
            <p className="vou-about mb-2">
              <span className="vou-about-title">Online :</span>{" "}
              www.kababhouse.com
            </p>
            <Link className="contact-btn">
              <p className="view">
                <MdCall /> Contact Seller
              </p>
            </Link>
          </Row>
          <div className="my-5">
            <Relateddeals
              id={coupon_id}
              about_business={coupondetail.about_business}
              relatedDealsList={relateddeals}
            />
          </div>
          <div className="my-5 other-deals-main">
            <OtherDeals id={coupon_id} otherDealsList={otherdeals} />
          </div>
        </div>
      </div>
      {/* })} */}
    </>
  );
};

export default CouponDetails;
